'use strict';

/**
 * 
 */
module.controller('NavigationCtrl', [ '$rootScope', '$scope', '$state', 'securityService', 'usSpinnerService', 'alertService',
		function($rootScope, $scope, $state, securityService, usSpinnerService, alertService) {
			$scope.loading = false;

			
		} ]);
